export default __webpack_public_path__ + "static/media/30t.a0849534.jpg";